var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cpf-cnpj-field',_vm._b({attrs:{"loading":_vm.loading,"disabled":_vm.loading},on:{"change":_vm.changed}},'cpf-cnpj-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }